<template lang="pug">
  .b-invitations
    ._item(v-for="item in itemsLocal")
      BaseInput._input(v-model="item.field.value" v-bind="item.field" :disabled="item.isSent || item.isSaving")
      div._status(v-if="item.isSaving") Сохранение...
      Btn(v-else-if="item.email !== item.field.value" @click="saveItem(item)") {{ 'Сохранить' }}
      div._status(v-else-if="item.isSent") Приглашение отправлено
      div._status(v-else-if="item.email !== ''") Сохранено
      Btn(v-if="!item.isSent" @click="deleteItem(item)") Удалить
    ._buttons
      Btn(@click="addItem") Добавить приглашение
</template>

<script>
import api from '@/api/invitation';
import form from '@/utils/form';

import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'UserInvitations',
  components: { BaseInput },
  props: {
    items: Array,
    projectIri: String,
  },
  data() {
    return {
      itemsLocal: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(val) { this.itemsLocal = (val ?? []).map(this.setupItem); },
    },
  },
  methods: {
    setupItem(item) {
      const constraints = { required: 'Укажите почту', email: 'Почта некорректна' };
      const field = form.createFieldObject('email', 'E-mail', item.email, constraints);

      return {
        ...item,
        field,
        isSaving: false,
      };
    },

    addItem() {
      this.itemsLocal.push(this.setupItem({ email: '' }));
    },
    saveItem(item) {
      form.validateField(item, 'field');

      if (item.isSaving || item.field.error) return;

      item.isSaving = true; // eslint-disable-line

      const data = {
        email: item.field.value,
        project: this.projectIri,
      };

      const promise = item.id
        ? api.update(item.id, data)
        : api.create(data);

      promise
        .then((r) => {
          item.id = r.id;         // eslint-disable-line
          item.email = r.email;   // eslint-disable-line
        })
        .finally(() => {
          item.isSaving = false;  // eslint-disable-line
        });
    },
    deleteItem(item) {
      this.itemsLocal = this.itemsLocal.filter((i) => i !== item);

      if (item.id) {
        api.delete(item.id);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .invitations {
    display: flex;
    flex-direction: column;
    column-gap: 30px;
    row-gap: 16px;

    &__item {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    &__input {
      width: 400px;
      margin-right: auto;
    }

    &__status {
      font-size: 13px;
      color: var(--color-middle-gray)
    }
  }
</style>
